import React, { useState, useRef, useEffect } from "react";

const TextAlignmentDropdown = ({ selectedField, updateField }) => {
  const [showAlignDropdown, setShowAlignDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Close if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRef.current.contains(e.target)
      ) {
        setShowAlignDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleButtonClick = () => {
    setShowAlignDropdown((prev) => !prev);
  };

  const setAlignment = (alignment) => {
    updateField(selectedField.id, { textAlign: alignment });
    setShowAlignDropdown(false);
  };

  // Determine which icon to show on the trigger button
  const triggerIcon =
    selectedField.textAlign === "center"
      ? "format_align_center"
      : selectedField.textAlign === "right"
      ? "format_align_right"
      : "format_align_left";

  return (
    <div className="relative inline-block">
      {/* Trigger */}
      <button
        ref={buttonRef}
        onClick={handleButtonClick}
        className={`
          py-1 px-2 border rounded flex items-center gap-1 transition text-color
          ${
            showAlignDropdown
              ? "bg-white/20 border-tier-secondary"
              : "bg-transparent"
          }
        `}
        title="Text alignment"
      >
        <span className="material-symbols-outlined text-base">
          {triggerIcon}
        </span>
        <span className="material-symbols-outlined">
          {showAlignDropdown ? "arrow_drop_up" : "arrow_drop_down"}
        </span>
      </button>

      {showAlignDropdown && (
        <div
          ref={dropdownRef}
          className="absolute bg-tier-primary dark:bg-tier-primary-dark dark:border-gray-600 border mt-1 w-28 z-10 rounded shadow"
          style={{
            left: buttonRef.current ? buttonRef.current.offsetLeft : 0,
          }}
        >
          {/* Left */}
          <button
            onClick={() => setAlignment("left")}
            className={`
              flex items-center space-x-2 w-full py-2 px-3 transition
              ${
                selectedField.textAlign === "left"
                  ? "bg-tier-secondary text-tier-primary"
                  : "hover:bg-white/20"
              }
            `}
          >
            <span className="material-symbols-outlined">format_align_left</span>
            <span>Left</span>
          </button>

          {/* Center */}
          <button
            onClick={() => setAlignment("center")}
            className={`
              flex items-center space-x-2 w-full py-2 px-3 transition
              ${
                selectedField.textAlign === "center"
                  ? "bg-tier-secondary text-tier-primary"
                  : "hover:bg-white/20"
              }
            `}
          >
            <span className="material-symbols-outlined">
              format_align_center
            </span>
            <span>Center</span>
          </button>

          {/* Right */}
          <button
            onClick={() => setAlignment("right")}
            className={`
              flex items-center space-x-2 w-full py-2 px-3 transition
              ${
                selectedField.textAlign === "right"
                  ? "bg-tier-secondary text-tier-primary"
                  : "hover:bg-white/20"
              }
            `}
          >
            <span className="material-symbols-outlined">
              format_align_right
            </span>
            <span>Right</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default TextAlignmentDropdown;
